export default "__VITE_ASSET__84e168c4__"